export enum StatusEnum {
    CLOSED = 'CLOS',
    ACTIVE = 'ACTIF',
    TERMINATED = 'RESILIE',
    INPROGRESS = 'EN CREATION',
    RETRACTED = 'RETRACTE',
}
